import React, { Component } from "react";
import { connect } from "react-redux";
import Axios from "axios-https-proxy-fix";
import { Dropdown, Checkbox } from "semantic-ui-react";
import SettingsWrapper from "../../../components/Settings/SettingsWrapper";
import Dialog from "@material-ui/core/Dialog";
import "./Warehouses.scss"
import translator from "../../../utils/translator";

export class Warehouses extends Component {
    state = {
        regions: [],
        region_id: 0,
        response: {},

        warehouses: [],
        deleted: {},
        open_dialog: false
    };

    // ============= AJAX FUNCTIONS =============

    callAjax = async (route, data) => {
        data.trendId = localStorage.getItem("trendId");
        data.token = localStorage.getItem("token");

        let APIResponse = await Axios.post(this.props.APIUrl + route, data);

        if (APIResponse.data.hasOwnProperty("error")) {
            this.setState({ response: { error: APIResponse.data.error } });
            return false;
        }
        this.setState({ response: {} });
        return APIResponse.data;
    };

    componentDidMount = async () => {
        let response = await this.callAjax("/warehouses/get-regions", {});
        this.setState({ regions: response.regions });
    };

    getWarehouses = async region_id => {
        let response = await this.callAjax("/warehouses/get-warehouses", { region_id: region_id });
        this.setState({ region_id: region_id, warehouses: response.warehouses });
    }

    saveWarehouses = async () => {
        this.setState({
            open_dialog: false,
            response: { loadingbar: translator("Misc", "loading_label") }
        });

        let state = this.state;
        let added = state.warehouses.filter(w => !!w.new && !!w.id).map(w => w.id);
        let deleted = Object.keys(state.deleted).filter(d => !!state.deleted[d]);
        let response = await this.callAjax(
            "/warehouses/save-warehouses",
            { added: added, deleted: deleted, region_id: state.region_id }
        );
        if (!!response.success) {
            let response = await this.callAjax("/warehouses/get-warehouses", { region_id: state.region_id });
            this.setState({
                response: { success: translator("Admin Warehouses", "warehouses_saved_message") },
                warehouses: response.warehouses,
                deleted: {}
            });
        }
    }

    // ============= RENDER FUNCTIONS =============

    renderRegions = state => {
        let region_options = state.regions.map(
            region => ({ value: region.id, text: (<div className="region_dropdown">{region.location_title}</div>) })
        );
        return (
            <div class="card user-profile-card mb1">
                <div class="card-body">
                    <Dropdown
                        fluid
                        selection
                        placeholder={translator("Admin Warehouses", "select_region")}
                        options={region_options}
                        onChange={(e, d) => this.getWarehouses(d.value)}
                    />
                </div>
            </div>
        );
    };

    renderSettings = state => {
        return (
            <div class="card user-profile-card">
                <div class="card-body">
                    <div className="warehouse-list">
                        {state.warehouses.map((warehouse, k) => (
                            <div
                                className={
                                    "warehouse-item " +
                                    (!!warehouse.new ? "new" : "") +
                                    (!!state.deleted[warehouse.id] ? "deleted" : "")
                                }
                                key={k}
                            >
                                <div className={"warehouse-id"}>
                                    {!!warehouse.new
                                        ? (
                                            <input
                                                type="text"
                                                className="form-control"
                                                value={warehouse.id}
                                                onChange={e => this.setState({
                                                    warehouses: state.warehouses.map(
                                                        (w, i) => k === i ? { ...w, id: e.target.value } : w
                                                    )
                                                })}
                                            />
                                        )
                                        : (
                                            <input
                                                type="text"
                                                className="form-control"
                                                value={warehouse.id}
                                                disabled
                                            />
                                        )
                                    }
                                </div>
                                {!!warehouse.new
                                    ? (
                                        <div className="warehouse-checkbox">
                                            <button
                                                className="btn btn-primary"
                                                onClick={() => this.setState({ warehouses: state.warehouses.filter((w, i) => i !== k) })}
                                            >
                                                {translator("Misc", "delete_label")}
                                            </button>
                                        </div>
                                    )
                                    : (
                                        <Checkbox
                                            label={translator("Misc", "delete_label")}
                                            className='warehouse-checkbox'
                                            value={warehouse.id}
                                            checked={!!state.deleted[warehouse.id]}
                                            onChange={() => this.setState({
                                                deleted: {
                                                    ...state.deleted,
                                                    [warehouse.id]: !state.deleted[warehouse.id]
                                                }
                                            })}
                                        />
                                    )
                                }
                            </div>
                        ))}
                        <button
                            className="btn btn-primary add-new"
                            onClick={() => this.setState({ warehouses: [...state.warehouses, { id: "", new: 1 }] })}
                        >
                            {translator("Admin Warehouses", "new_warehouse_btn")}
                        </button>
                    </div>
                    <button
                        className="btn btn-primary save-btn"
                        onClick={() => this.setState({ open_dialog: true })}
                    >
                        {translator("Admin Warehouses", "submit_btn")}
                    </button>
                </div>
            </div>
        );
    };

    renderDialog = state => {
        return (
            <Dialog open={state.open_dialog} onClose={() => this.setState({ open_dialog: false })}>
                <div class="quote-dialog warehouses-verify-dialog">
                    <div class="quote-dialog-title">{translator("Admin Warehouses", "edit_warehouses_dialog_title")}</div>
                    <div class="quote-dialog-body">
                        <div class="quote-dialog-info">
                            <div>
                                <div className="em1">{translator("Admin Warehouses", "edit_warehouses_dialog_message")}</div>
                                {state.warehouses.filter(w => !!w.new && !!w.id).map(warehouse => (
                                    <div className="added-line">
                                        {translator("Misc", "added_label")}: {warehouse.id}
                                    </div>
                                ))}
                                {Object.keys(state.deleted).filter(d => !!state.deleted[d]).map(warehouse_id => (
                                    <div className="deleted-line">
                                        {translator("Misc", "deleted_label")}: {warehouse_id}
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>

                    <div class="quote-dialog-footer">
                        <button class="quote-dialog-button" onClick={this.saveWarehouses}>
                            {translator("Misc", "yes_btn")}
                        </button>
                        <button class="quote-dialog-button" onClick={() => this.setState({ open_dialog: false })}>
                            {translator("Misc", "no_btn")}
                        </button>
                    </div>
                </div>
            </Dialog>
        );
    }

    renderResponse = response => {
        if (Object.keys(response).length === 0) return null;
        let key = "error";
        if (response.hasOwnProperty("success")) key = "success";
        if (response.hasOwnProperty("loadingbar")) key = "loadingbar";
        let cardClass = "card user-profile-card response-" + key;
        return (
            <div className={cardClass}>
                <div class="card-body">{response[key]}</div>
            </div>
        );
    };

    render() {
        let state = this.state;
        let main = (
            <>
                {this.renderRegions(state)}
                {state.region_id ? this.renderSettings(state) : null}
                {state.region_id ? this.renderDialog(state) : null}
                {Object.keys(state.response).length ? this.renderResponse(state.response) : null}
            </>
        );
        return (
            <SettingsWrapper header={translator("Admin Warehouses", "page_title")} main={main} classes="edit-warehouses" />
        );
    }
}

const mapStateToProps = state => ({
    APIUrl: state.APIUrl,
    selected_language: state.selected_language
});

const mapDispatchToProps = {};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Warehouses);
